import { useTranslation } from 'react-i18next'

// local imports & assets
import carGray from 'assets/icons/car-gray.svg'
import parkGray from 'assets/icons/park-area-gray.svg'
import { IAvailableParkAreas, IFilteredParkAreaList } from 'types/ParkAreaType'
import DateUtil from 'utils/DateUtil'
import ParkAreaCard from './ParkAreaCard'
import { InfoCard, InfoCardContent, InfoCardHeader } from './styled'

interface ListRenderProps {
  availableParkAreas: IAvailableParkAreas
  openModal: (area: IFilteredParkAreaList) => void
}

interface InfoRenderProps {
  availableParkAreas: IAvailableParkAreas
}

export default function ParkAreaListRender({ availableParkAreas, openModal }: ListRenderProps) {
  /* Render parkAreas or filtered Park Area list */
  const renderList = availableParkAreas?.parkAreas
  const { firmName, locationName: locName, blockName, floorName } = availableParkAreas || {}
  const locationName = `${locName}, ${firmName},  ${blockName}, ${floorName}`

  return (
    <>
      {!!renderList?.length ? (
        <>
          <RenderInfoCard availableParkAreas={availableParkAreas} />

          {/* Park Area List - Cards */}
          {renderList.map((area) => (
            <ParkAreaCard openModal={openModal} key={area.id} parkArea={area} locationName={locationName} />
          ))}
        </>
      ) : (
        <RenderInfoCard availableParkAreas={availableParkAreas} />
      )}
    </>
  )
}

function RenderInfoCard({ availableParkAreas }: InfoRenderProps) {
  const { t } = useTranslation()
  const reservationInfo = availableParkAreas?.parkAreaReservation
  const { cityName, countryName, districtName, locationName } = availableParkAreas || {}
  const hasReservation = !!reservationInfo
  const locationStr = `${locationName}, ${districtName}, ${cityName}, ${countryName}`

  return (
    <InfoCard>
      <InfoCardHeader>{t('park-area-res-modal.common-res')}</InfoCardHeader>
      <InfoCardContent>
        <div className="info-header">{availableParkAreas?.firmName}</div>
        <div className="info-content">{locationStr}</div>

        <div className="info-content">
          <span className="info-date">{t('park-area-res-modal.common-res-date')}:</span>
          <span> {DateUtil.dateFormat(availableParkAreas?.reservationDate)}</span>
        </div>

        {/* Parking lot reservation */}
        {hasReservation ? (
          <>
            <div className="info-content d-flex align-items-center">
              <img src={parkGray} width={24} height={24} alt="plate_number" />
              <span className="mx-1 info-date">{t('tabs.park-area')}: </span>
              <span>{reservationInfo?.parkAreaName}</span>
            </div>

            <div className="info-content d-flex align-items-center">
              <img src={carGray} width={24} height={24} alt="plate_number" />
              <span className="mx-1 info-date"> {t('park-area-res-modal.licence-plate')}: </span>
              <span>{reservationInfo?.plate}</span>
            </div>
          </>
        ) : null}
      </InfoCardContent>
    </InfoCard>
  )
}
